<template>
    <div
        class="tooltip"
        @click="toggleOnClick"
        @mouseover="visible = true"
        @mouseout="hideTooltip"
        v-click-outside="hideTooltip"
    >
        <div>
            <slot name="label"></slot>
        </div>

        <span class="tooltiptext" :class="`tooltip-${position} ${tooltipClasses}`" v-show="visible">
            <slot name="tooltip"></slot>
        </span>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
    props: {
        position: {
            type: String,
            default: 'top',
            validator: val => ['top', 'bottom', 'left', 'right'].includes(val)
        },
        tooltipClasses: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            visible: false
        };
    },
    methods: {
        toggleOnClick: debounce(function(e) {
            if (this.visible) return;

            this.visible = !this.visible;
        }, 300),
        hideTooltip() {
            this.visible = false;
        }
    }
};
</script>

<style>
.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tooltiptext {
    visibility: visible;
    background-color: white;
    color: #776778;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
    width: 300px;
    position: absolute;
    z-index: 1;
    box-shadow: 0 5px 19px -9px #777;
    padding: 10px;
}

.tooltip-top {
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
}

.tooltip-bottom {
    top: 100%;
    left: 50%;
    margin-left: -60px;
}

.tooltip-left {
    top: -8px;
    right: 105%;
}

.tooltip-right {
    top: -8px;
    left: 105%;
}

@media only screen and (max-width: 600px) {
    .tooltip-left-sm {
        top: -8px !important;
        right: 105% !important;
        bottom: auto;
        left: auto;
    }
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>
